/* eslint-disable @typescript-eslint/naming-convention */
import { styled } from '@mui/material/styles'
import {
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
} from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const HeaderCell = styled(MuiTableCell)`
  font-weight: bold;
  background-color: ${colors.background.secondaryBackground};
  border-bottom: none;
  padding: 16px;
  display: flex;
  align-items: center;
`

export const HeaderTaskContentContainer = styled(HeaderCell)`
  ${typography.down1.semiBoldSans}
  justify-content: flex-start;
  flex: 5;
`

export const HeaderDueDateContainer = styled(HeaderCell)`
  ${typography.down1.semiBoldSans}
  flex: 2;
`

export const HeaderTaskActionsContainer = styled(HeaderCell)`
  ${typography.down1.semiBoldSans}
  flex: 1;
`

export const TableRow = styled(MuiTableRow, {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})<{ isHeader?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border-bottom: 1px solid ${colors.divider};

  &:hover {
    background-color: ${({ isHeader }) =>
      isHeader ? 'inherit' : colors.illustration.lightBlue10};
  }

  ${({ isHeader }) =>
    isHeader &&
    `
    background-color: ${colors.background.secondaryBackground};
    font-weight: bold;
  `}
`
